import React from 'react';

import styled, { css } from 'styled-components';

import { Link } from '~/techstyle-shared/next-routes';
import { AssetContainer } from '~/techstyle-shared/react-assets';
import {
  useBreakpoint,
  Button,
  Video,
  mobile,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const Wrapper = styled.div`
  display: flex;
  min-height: 634px;
  padding: 50px 0;
`;

const VideoWrapper = styled.div`
  flex: 1 0 50%;
`;

const Content = styled.div`
  flex: 1 0 50%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 30px;
  line-height: 37px;
  color: ${({ theme }) => theme.colors.textDefault};
`;

const TextCopy = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textDefault};
  padding: 0 15%;
  margin: 20px 0;

  ${mobile`
    padding: 0 3%;
  `}
`;

const Subtitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 2px;
  color: ${({ theme }) => theme.colors.textDefault};
  margin-top: 20px;
`;

const Subcopy = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.sublabelBlack};
`;

const StyledButton = styled(Button)`
  margin-top: 30px;
`;

export default function FitAppPageWorkouts() {
  const { isMobile } = useBreakpoint();
  const video = (
    <AssetContainer
      name={
        isMobile ? 'fitnessapp_content3_mobile' : 'fitnessapp_content3_desktop'
      }
    >
      {({ data }) =>
        data ? (
          <Video
            aspectRatio={1100 / 1690}
            wrapperStyle={
              !isMobile
                ? css`
                    width: 100%;
                    height: 100%;

                    &::before {
                      padding: 0;
                    }
                  `
                : css`
                    width: 100%;
                  `
            }
            hasControls={false}
            url={Video.getUrlFromVideoId(data.options.customVars?.VideoID)}
          />
        ) : null
      }
    </AssetContainer>
  );

  return (
    <Wrapper>
      {!isMobile && <VideoWrapper>{video}</VideoWrapper>}
      <Content>
        <Title>
          <FormattedMessage
            defaultMessage="Customize Your Workouts"
            id="fitness_app.section_4_title"
          />
        </Title>
        <TextCopy>
          <FormattedMessage
            defaultMessage="Build the perfect routine and filter hunders of workouts by duration, equipment, and category"
            id="fitness_app.section_4_copy"
          />
        </TextCopy>

        {isMobile && video}
        <Subtitle>
          <FormattedMessage
            defaultMessage="CLASSES"
            id="fitness_app.section_4_subtitle1"
          />
        </Subtitle>
        <Subcopy>
          <FormattedMessage
            defaultMessage="On-demand and led by professional instructors from top fitness studios."
            id="fitness_app.section_4_subcopy1"
          />
        </Subcopy>
        <Subtitle>
          <FormattedMessage
            defaultMessage="SELF-GUIDED SESSIONS"
            id="fitness_app.section_4_subtitle2"
          />
        </Subtitle>
        <Subcopy>
          <FormattedMessage
            defaultMessage="Strengthen specific muscle groups in 5 to 20-minute increments"
            id="fitness_app.section_4_subcopy2"
          />
        </Subcopy>
        <Link
          href="https://apps.apple.com/us/app/fabletics-fit/id1505326423"
          passHref
        >
          <StyledButton>
            <FormattedMessage
              defaultMessage="DOWNLOAD NOW"
              id="fitness_app.download"
            />
          </StyledButton>
        </Link>
      </Content>
    </Wrapper>
  );
}
